import { render, staticRenderFns } from "./AgencyFeesAndCharges.vue?vue&type=template&id=40ccde96&scoped=true&"
import script from "./AgencyFeesAndCharges.vue?vue&type=script&lang=ts&"
export * from "./AgencyFeesAndCharges.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyFeesAndCharges.vue?vue&type=style&index=0&id=40ccde96&prod&scoped=true&lang=css&"
import style1 from "./AgencyFeesAndCharges.vue?vue&type=style&index=1&id=40ccde96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ccde96",
  null
  
)

export default component.exports